export default "__VITE_ASSET__mQ$zFtQh__"